module.exports = __webpack_public_path__ + "static/grain-background-2198b2b8256e562d5b2c19fa008b10d1.png";